import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const SERVICES = [
    {
        n: "S.01",
        title: "Manual joint mobilization",
        desc: "Skilled hands-on techniques to restore stiff, painful joint movement.",
    },
    {
        n: "S.02",
        title: "Sports & movement rehab",
        desc: "Return-to-sport programming built around the demands of your game.",
    },
    {
        n: "S.03",
        title: "Postural & spine alignment",
        desc: "Assessment and correction for neck, back and desk-related strain.",
    },
    {
        n: "S.04",
        title: "Soft tissue & myofascial release",
        desc: "Targeted release work for muscle tension, scar tissue and overuse.",
    },
    {
        n: "S.05",
        title: "Pre & post-surgical recovery",
        desc: "Structured rehabilitation before and after orthopaedic surgery.",
    },
];

export const Services = () => (
    <section id="services" data-testid="services-section" className="border-b border-line bg-sand">
        <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
            <div className="mb-14 flex flex-wrap items-end justify-between gap-6">
                <div>
                    <p
                        className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-mutedink"
                        data-testid="services-label"
                    >
                        Services
                    </p>
                    <h2
                        className="font-syne text-3xl font-semibold tracking-tight sm:text-4xl lg:text-5xl"
                        data-testid="services-title"
                    >
                        Hands-on treatment,
                        <br />
                        <span className="font-cormorant italic font-medium text-ochre">nothing passive.</span>
                    </h2>
                </div>
                <p className="max-w-sm text-base leading-relaxed text-mutedink">
                    Every appointment is one-on-one with a registered physiotherapist. No aides, no
                    hand-offs, no machines doing the work.
                </p>
            </div>
            <div className="grid grid-cols-1 border border-line sm:grid-cols-2 lg:grid-cols-3">
                {SERVICES.map((s, i) => (
                    <motion.div
                        key={s.n}
                        data-testid={`service-card-${i + 1}`}
                        initial={{ opacity: 0, y: 32 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.7, delay: i * 0.06, ease: EASE }}
                        className="group border-line bg-bone p-8 transition-all duration-300 hover:-translate-y-1 hover:bg-white [&:not(:nth-child(3n))]:lg:border-r sm:odd:border-r lg:odd:border-r-0 border-b sm:[&:nth-child(n+5)]:border-b-0 lg:[&:nth-child(n+4)]:border-b-0"
                    >
                        <span className="font-mono text-xs text-ochre">{s.n}</span>
                        <h3 className="mt-4 font-syne text-xl font-medium tracking-tight sm:text-2xl">
                            {s.title}
                        </h3>
                        <p className="mt-3 text-sm leading-relaxed text-mutedink">{s.desc}</p>
                        <span className="mt-6 block h-px w-8 bg-ink transition-all duration-500 group-hover:w-full group-hover:bg-ochre" />
                    </motion.div>
                ))}
                <motion.figure
                    data-testid="services-photo"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.9, ease: EASE }}
                    className="relative overflow-hidden"
                >
                    <img
                        src="https://images.unsplash.com/photo-1552196527-bffef41ef674?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
                        alt="Athlete performing an active spine stretch"
                        className="h-full min-h-[280px] w-full object-cover grayscale-[35%] transition-transform duration-700 hover:scale-[1.03]"
                        loading="lazy"
                    />
                    <span className="absolute bottom-4 left-4 bg-bone px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em]">
                        Fig. 05 — Movement is the goal
                    </span>
                </motion.figure>
            </div>
        </div>
    </section>
);
